$( document ).ready(function() { jQuery(function ($) {

  $('.col-full').addClass('container-fluid').removeClass('col-full');
  $('.current-menu-parent').addClass('current-menu-item');
  $('#content').css({'min-height': ($(window).height()-40)+'px'});
  $('#secondary').css({'min-height': ($('#content .container-fluid').height()-40)+'px'});
  $('.fullscreen-iframe').css({'min-height': ($(window).height())+'px'});

  // Set Notification Defaults
  $.notify.defaults(
    {
      autoHide: true,
      arrowShow: false,
      position: 'bottom left'
    }
  );


  $('textarea:not(.hide)').each(function () {

    $(this).animate({
        height: (this.scrollHeight)
    }, "normal", function() {
        this.setAttribute('style', 'height:'+(this.scrollHeight)+'px;overflow-y:hidden;');
    });

  }).on('input', function () {
    this.style.height = 'auto';
    this.style.height = (this.scrollHeight) + 'px';
  });


  $(function() {
    $('a[href*="#"]:not([href="#"])').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        if (this.hash.slice(1).toLowerCase().indexOf("tab") < 0){
          target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
          if (target.length) {
            $('html, body').animate({
              scrollTop: target.offset().top
            }, 1000);
            return false;
          }
        }
      }
    });
  });

  $.fn.extend({
      animateCss: function (animationName) {
          var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
          $(this).addClass('animated ' + animationName).one(animationEnd, function() {
              $(this).removeClass('animated ' + animationName);
          });
      }
  });

  setTimeout(function(){
      // $('#content').css('visibility','visible');
      // $('#content').css('animation-duration', '0.5s');  
      // $('#content').animateCss('fadeIn');
      $('.getstarted a').css('visibility','visible');
      $('.getstarted a').css('animation-duration', '0.5s');  
      $('.getstarted a').animateCss('fadeIn');
      $('h1').css('visibility','visible');
      $('h1').css('animation-delay', '0.2s');
      $('h1').css('animation-duration', '0.5s');
      $('h1').animateCss('bounceIn');
      AOS.init({
        offset: 100,
        duration: 200,
        easing: 'ease-in-sine',
        delay: 100,
      });
  }, 500);

  // $(".sub-menu, .site-header-cart").click(function() {
  //   $('.sub-menu li, .widget_shopping_cart_content').css('opacity','0');
  // });

    //  $("a").click(function(e) { 
    //   // Removed this (this.href.indexOf("?") < 0 ) && 
    //   if (!(e.shiftKey || e.ctrlKey || e.metaKey)) {
    //  	if ((!/#/.test(this.href)) && (! $(this).closest(".search").length ) && (! $(this).closest(".modal").length ) && (! $(this).closest(".zoom").length )   && (! $(this).closest(".wizard").length )  && (! $(this).closest(".nofade").length ) && (! $(this).closest(".VuePagination").length )) {
    //     $('#content').css('animation-duration', '0.2s');
		  //   var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
		  //   $('#content').addClass('animated fadeOut').one(animationEnd, function() {
				// $('#content').css('visibility','hidden');
		  //   });
    // 	}}
    // });
});});